import React, { useState, useEffect } from 'react';
import { resolveImg } from '../api';

// Reliable Pexels fallback images grouped by theme (used when Unsplash URL fails)
const FALLBACKS = {
  beach: 'https://images.pexels.com/photos/1533720/pexels-photo-1533720.jpeg?auto=compress&cs=tinysrgb&w=1200',
  mountain: 'https://images.pexels.com/photos/572897/pexels-photo-572897.jpeg?auto=compress&cs=tinysrgb&w=1200',
  city: 'https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&w=1200',
  couple: 'https://images.pexels.com/photos/842711/pexels-photo-842711.jpeg?auto=compress&cs=tinysrgb&w=1200',
  wildlife: 'https://images.pexels.com/photos/667205/pexels-photo-667205.jpeg?auto=compress&cs=tinysrgb&w=1200',
  family: 'https://images.pexels.com/photos/1157393/pexels-photo-1157393.jpeg?auto=compress&cs=tinysrgb&w=1200',
  adventure: 'https://images.pexels.com/photos/2422915/pexels-photo-2422915.jpeg?auto=compress&cs=tinysrgb&w=1200',
  temple: 'https://images.pexels.com/photos/2846215/pexels-photo-2846215.jpeg?auto=compress&cs=tinysrgb&w=1200',
  default: 'https://images.pexels.com/photos/1802255/pexels-photo-1802255.jpeg?auto=compress&cs=tinysrgb&w=1200',
};

const SafeImage = ({ src, alt, fallbackType = 'default', className = '' }) => {
  const initial = resolveImg(src) || FALLBACKS[fallbackType] || FALLBACKS.default;
  const [current, setCurrent] = useState(initial);
  const [triedFallback, setTriedFallback] = useState(false);

  // Reset when the prop changes (e.g. list refresh)
  useEffect(() => {
    setCurrent(resolveImg(src) || FALLBACKS[fallbackType] || FALLBACKS.default);
    setTriedFallback(false);
  }, [src, fallbackType]);

  const handleError = () => {
    if (!triedFallback) {
      setCurrent(FALLBACKS[fallbackType] || FALLBACKS.default);
      setTriedFallback(true);
    }
  };

  return <img src={current} alt={alt} className={className} onError={handleError} loading="lazy" />;
};

export default SafeImage;
